var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url === '')?_c('svg',_vm._g({class:_vm.svgClass,attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_c('img',_vm._g({class:_vm.imgClass,attrs:{"src":_vm.iconUrl}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }